/**
 * @generated SignedSource<<c1596149569a3741f513c7a159088912>>
 * @relayHash d60f670b5b542257318c82acd27bdf2c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/576.0.0-2026-09-09T15:31:58.279Z/nftItemTileUpdateSubscription

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftItemUpdateSubscriptionInput = {
  itemId: string;
};
export type nftItemTileUpdateSubscription$variables = {
  fetchUser: boolean;
  input: NftItemUpdateSubscriptionInput;
  userId: string;
};
export type nftItemTileUpdateSubscription$data = {
  readonly nftItemUpdate: {
    readonly nftItem: {
      readonly " $fragmentSpreads": FragmentRefs<"CollectorTileContent_nftItem">;
    } | null;
  } | null;
};
export type nftItemTileUpdateSubscription = {
  response: nftItemTileUpdateSubscription$data;
  variables: nftItemTileUpdateSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileName",
      "storageKey": null
    },
    (v4/*:: as any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v8 = [
  (v7/*:: as any*/),
  (v4/*:: as any*/)
],
v9 = [
  {
    "kind": "Literal",
    "name": "excludeCanceled",
    "value": true
  }
],
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "auctionId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "EthereumAddressType",
    "kind": "LinkedField",
    "name": "contractAddress",
    "plural": false,
    "selections": (v8/*:: as any*/),
    "storageKey": null
  },
  (v4/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "nftItemTileUpdateSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "NftItemUpdateSubscriptionPayload",
        "kind": "LinkedField",
        "name": "nftItemUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItem",
            "kind": "LinkedField",
            "name": "nftItem",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CollectorTileContent_nftItem"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscriptions",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "nftItemTileUpdateSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "NftItemUpdateSubscriptionPayload",
        "kind": "LinkedField",
        "name": "nftItemUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItem",
            "kind": "LinkedField",
            "name": "nftItem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "creatorAddress",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "publicProfileUrl",
                    "storageKey": null
                  },
                  (v5/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "edition",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftDigitalArtMetadataMedia",
                        "kind": "LinkedField",
                        "name": "media",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "webUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "posterFrameUrl",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "NftDigitalArtMetadata",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LinkData",
                "kind": "LinkedField",
                "name": "linkData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "path",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isLinkable",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalSupply",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isERC1155",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EthereumAddressType",
                "kind": "LinkedField",
                "name": "ownerAddress",
                "plural": false,
                "selections": [
                  (v7/*:: as any*/),
                  (v5/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ensDomain",
                    "storageKey": null
                  },
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tokenId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tokenUri",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NftTokenContract",
                "kind": "LinkedField",
                "name": "contract",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v4/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EthereumAddressType",
                    "kind": "LinkedField",
                    "name": "addressWithFields",
                    "plural": false,
                    "selections": (v8/*:: as any*/),
                    "storageKey": null
                  },
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "serviceId",
                "storageKey": null
              },
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "userId",
                        "variableName": "userId"
                      }
                    ],
                    "concreteType": "NftItemBalance",
                    "kind": "LinkedField",
                    "name": "balanceForUser",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "balance",
                        "storageKey": null
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ]
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wasBurned",
                "storageKey": null
              },
              {
                "alias": "recentAuction",
                "args": (v9/*:: as any*/),
                "concreteType": "NftAuction",
                "kind": "LinkedField",
                "name": "mostRecentAuction",
                "plural": false,
                "selections": (v10/*:: as any*/),
                "storageKey": "mostRecentAuction(excludeCanceled:true)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pdpUrl",
                "storageKey": null
              },
              {
                "alias": "auction",
                "args": (v9/*:: as any*/),
                "concreteType": "NftAuction",
                "kind": "LinkedField",
                "name": "mostRecentAuction",
                "plural": false,
                "selections": (v10/*:: as any*/),
                "storageKey": "mostRecentAuction(excludeCanceled:true)"
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/576.0.0-2026-09-09T15:31:58.279Z/nftItemTileUpdateSubscription",
    "metadata": {},
    "name": "nftItemTileUpdateSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "8b47868cf76d3fd81d0a9143f9f94895";

export default node;
